import classNames from "classnames";
import getOr from 'lodash/fp/getOr';
import { LocalStorage } from "../../models/LocalStorage";
import { Product } from "../../models/Product";
import { getPriceText } from "../../utils/currency";
import { MINI_APP } from "../../utils/miniApp";
import { isMobileByWidth } from "../../utils/utils";
import { DComponent } from "../DComponent";

const TYPE_DISPLAY = {
  NORMAL: 0,
  POPUP: 1
}

export default class ProductInfoItem extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    productItem = new Product(),
    type = TYPE_DISPLAY.NORMAL,
    isPrivateInfo = false,
    hideHead = false
  } = {}) {
    let originPriceText = productItem.meta?.originPrice && productItem.sitePriceCur && productItem.meta?.originPrice > productItem.sitePrice ? getPriceText(productItem.meta.originPrice, productItem.sitePriceCur) : "";
    super(arguments[0], parent, id, {
      class: classNames("ProductInfoItem", {
        "is-rfq": productItem.type === Product.TYPE_PRODUCT.RFQ.id,
        "no-color": !isPrivateInfo && !getOr("", "meta.color")(productItem),
        "no-size": !isPrivateInfo && !getOr("", "meta.size")(productItem),
        "popup": type === TYPE_DISPLAY.POPUP,
        "hide-head": hideHead,
        "has-origin-price": originPriceText,
      }),
      quantity: isPrivateInfo ? "--" : productItem.quantity,
      title: isPrivateInfo ? "" : getOr("", "meta.title")(productItem),
      titleI18n: isPrivateInfo ? "productItem_productNameDefault" : "",
      image: isPrivateInfo ? require("../../assets/images/tracking/product_default.jpg") : (getOr("", "meta.image")(productItem) || (LocalStorage.getLanguage() === "vi" ? require("../../assets/images/search/img_default_vi.jpg") : require("../../assets/images/search/img_default_en.jpg"))),
      color: isPrivateInfo ? "--" : getOr("", "meta.color")(productItem),
      size: isPrivateInfo ? "--" : getOr("", "meta.size")(productItem),
      productUrl: isPrivateInfo ? "" : getOr("", "meta.currentUrl")(productItem) || productItem.siteUrl,
      sitePrice: isPrivateInfo ? "--" : getPriceText(productItem.sitePrice, productItem.sitePriceCur),
      currentPrice: isPrivateInfo ? "--" : getPriceText(productItem.price, productItem.currentCurrency),
      siteLogo: productItem.siteLogo || `https://www.google.com/s2/favicons?domain=${productItem.siteUrl}`,
      siteName: productItem.siteName,
      classPurchased: !productItem.siteLogo && !productItem.siteName ? "hide" : "",
      originPrice: isPrivateInfo ? "--" : originPriceText,
    }, true, defaultLoading);
    this.productItem = productItem;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ProductInfoItem");
  }

  loadHtml() {
    return isMobileByWidth() ? require("html-loader!./itemMobile.html") : require("html-loader!./item.html");
  }

  after() {
    this.setNote();

    if (LocalStorage.isMiniApp()) {
      this.element.on("click", "a", (e) => {
        e.preventDefault();
        MINI_APP.openSite({
          url: $(e.currentTarget).attr("href")
        });
      });
    }
  }

  setNote() {
    let noteOOS = this.productItem.getNoteType(Product.TYPE_NOTES.OOS);
    if (noteOOS) {
      $(".warning", this.element).text(noteOOS.text || $.i18n("checkout_itemOOS")).attr("type", Product.TYPE_NOTES.OOS);
    } else {
      $(".warning", this.element).text("").attr("type", "");
    }
  }
}